<template>
  <div class="text-center mt-5">
    <div>Jungiamasi prie Entra ID...</div>
  </div>
</template>

<script>
// import { userService } from "../_Services/user-service";
// import { msalInstance } from '.././msalConfig';

export default {
  name: "entraid-login-page",
  components: { },
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  async mounted() {
    console.log("Entra ID login page mounted");
  }
};
</script>

<style lang="css" scoped></style>